import { createApp, inject, provide } from "vue";
import productCart from "./ProductCart.vue";

const app = createApp({
  components: {
    "product-cart": productCart,
  },
}).mount("#container-cart");
